import { getFormattedDate } from '../utils/utils';
import { getStatus, getOrderType } from './utils';

const findOrderType = {
  'New Business Apps to TELUS Customer Order':'New',
  'Existing Business Apps Customer mid-term change order (add SKU /quantity change / upgrade / downgrade)':'Change',
  'Existing Business Apps Customer Renewal / with change (add / remove SKU /quantity change / upgrade / downgrade)':'Renewal',
  'Existing Business Apps Customer Cancellation':'Cancel'
}
export class OrderListModel {
  constructor(data) {
    const {
      status,
      quoteStatus,
      productSelectionOCDR,
      orderId,
      createdAt,
      updatedAt,
      orderCreatedBy,
      orderAssignedTo,
      channel,
      companyNameOCDR,
      completedAt,
      firstName: creatorFirstName,
      lastName: creatorLastName,
      orderCreatedBy: { firstName, lastName },
      orderRequestType
    } = data || {};
    this.status = getStatus(status, quoteStatus) || '-';
    this.createdBy = orderCreatedBy
      ? `${orderCreatedBy.firstName} ${orderCreatedBy.lastName}`
      : '';
    this.channel = channel ? channel.name : '-';
    this.typeOfInstallation = getOrderType(productSelectionOCDR);
    this.orderId = orderId;
    this.updatedAt =
      (updatedAt && getFormattedDate(updatedAt, 'YYYY-MM-DD')) || '-';
    this.createdAt =
      (createdAt && getFormattedDate(createdAt, 'YYYY-MM-DD')) || '-';
    this.completedAt =
      (completedAt && getFormattedDate(completedAt, 'YYYY-MM-DD')) || '-';  
    this.assignee =
      orderAssignedTo && orderAssignedTo.length
        ? orderAssignedTo[0].label
        : '-';
    this.legalBusinessName = companyNameOCDR ? companyNameOCDR : '-';
    this.orderType = orderRequestType ? findOrderType[orderRequestType] : '-';
    this.salesRepName = creatorFirstName ? `${creatorFirstName} ${creatorLastName}`: `${firstName} ${lastName}`;
  }
}
